import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=7c449e1f&"
import script from "./Review.vue?vue&type=script&lang=js&"
export * from "./Review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c449e1f')) {
      api.createRecord('7c449e1f', component.options)
    } else {
      api.reload('7c449e1f', component.options)
    }
    module.hot.accept("./Review.vue?vue&type=template&id=7c449e1f&", function () {
      api.rerender('7c449e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Components/Steps/Review.vue"
export default component.exports